










































































































import Vue from 'vue';
import RestX from 'highered-utils/restx';
import clamp from 'lodash/clamp';
import FacebookLogo from '~/assets/img/Facebook.png';
import InstagramLogo from '~/assets/img/Instagram.png';
import LinkedInLogo from '~/assets/img/LinkedIn.png';
import TwitterLogo from '~/assets/img/Twitter.png';
import defaultBackground from '~/assets/img/vcf/company-default-bg.png';
import VimeoLogo from '~/assets/img/Vimeo.png';
import WeChatLogo from '~/assets/img/WeChat.png';
import YouTubeLogo from '~/assets/img/YouTube.png';
import { VFairType, VFairWebinar } from '~/services/types/vfair';
import { SHOW_CHAT_IN_COMPANY_PROFILE } from '~/router';
import AnalyticService from '~/services/AnalyticService';
import AuthService from '~/services/AuthService';
import { ChatUser } from '~/services/TalkJSService';
import { VFairOrganization } from '~/services/VFairService';
import PostingModule from '~/shared/postingmodule/PostingModule.vue';
import URLS from '~/URLS';
import { joinIfTruthy } from '~/utils';
import SubLayout from '../../../components/layouts/mainlayout/SubLayout.vue';
import CompanyBadge from './components/CompanyBadge.vue';
import WebinarList from './components/WebinarList.vue';
import VideoList from './components/VideoList.vue';
import BoothFAQ from './components/BoothFAQ.vue';

interface ExternalLink {
    id: string;
    href: string;
    title: string;
    icon: string;
    color: string;
    backgroundColor: string;
    isFontAwesome?: boolean;
}

export default Vue.extend({
    name: 'Booth',
    components: {
        SubLayout,
        PostingModule,
        WebinarList,
        VideoList,
        CompanyBadge,
        BoothFAQ,
    },
    props: {
        vFairType: {
            type: Number,
            default: VFairType.Standard,
        },
    },
    data() {
        return {
            boothId: '',

            company: null as VFairOrganization | null,
            companyLoaded: false,
            now: 0,
            chatAvailabilityIntervalSeconds: 5,
            chatAvailabilityInterval: null as number | null,
            hasLoggedEvent: false,

            chatUsersIndex: 0,

            facebookLogo: FacebookLogo,
            twitterLogo: TwitterLogo,
            youTubeLogo: YouTubeLogo,
            linkedInLogo: LinkedInLogo,
            instagramLogo: InstagramLogo,
            weChatLogo: WeChatLogo,
            vimeoLogo: VimeoLogo,
        };
    },
    computed: {
        interfaces(): any {
            return (this as any).$interfaces;
        },
        URLS(): typeof URLS {
            return (this as any).$URLS as typeof URLS;
        },

        isSchoolAdmission(): boolean {
            return this.vFairType == VFairType.SchoolAdmission;
        },
        isYouTubeBackground(): boolean {
            if (!this.company) return false;
            return this.company.backgroundImage.includes('youtube.com/embed');
        },

        emailUri(): string {
            if (!this.company || !this.company.email) return '';

            if (this.company.email.toLowerCase().startsWith('mailto:')) return this.company.email;
            else return 'mailto:'.concat(this.company.email);
        },
        jobs(): any[] {
            return this.interfaces.posting.get({
                reactive: true,
                vfair_id: this.$route.params.id,
                company_id: this.boothId,
            }).data;
        },
        pavilionId(): string {
            return this.interfaces.vfairModule.getPavilionId();
        },

        chatUsers(): ChatUser[] {
            if (!this.company) return [];

            const available: { data?: ChatUser[] } = SHOW_CHAT_IN_COMPANY_PROFILE
                ? this.interfaces.communication.chat.availability.id
                      .org_id(this.$route.params.boothId)
                      .get({ reactive: true })
                : {};

            if (!available.data) return [];
            const users = available.data
                .filter(cu => cu.availableUntil > this.now)
                .map(item => ({
                    ...item,
                    boothId: this.company!.organizationId,
                    companyTitle: this.company!.title,
                }));

            return users;
        },
        visibleChatUsers(): ChatUser[] {
            return this.chatUsers.slice(this.chatUsersIndex, this.chatUsersIndex + 3);
        },
        showChatUsers(): boolean {
            return SHOW_CHAT_IN_COMPANY_PROFILE && !!this.chatUsers.length;
        },
        showChatLeftArrow(): boolean {
            return this.showChatUsers && this.chatUsers.length > 3 && this.chatUsersIndex > 0;
        },
        showChatRightArrow(): boolean {
            return (
                this.showChatUsers &&
                this.chatUsers.length > 3 &&
                this.chatUsersIndex < this.chatUsers.length - 3
            );
        },

        links(): ExternalLink[] {
            if (!this.company) return [];

            return [
                {
                    id: 'url',
                    title: this.$t('vfair.companies.visitWebsite').toString(),
                    icon: 'link',
                    href: this.company.url,
                    color: '#777',
                    backgroundColor: '#eee',
                    isFontAwesome: true,
                },
                {
                    id: 'email',
                    title: this.$t('vfair.companies.sendMail').toString(),
                    icon: 'envelope',
                    href: this.emailUri,
                    color: '#777',
                    backgroundColor: '#eee',
                    isFontAwesome: true,
                },
                {
                    id: 'you_tube',
                    title: 'YouTube',
                    icon: this.youTubeLogo,
                    href: this.company.youTube,
                    color: '#fff',
                    backgroundColor: '#f00',
                },
                {
                    id: 'twitter',
                    title: 'Twitter',
                    icon: this.twitterLogo,
                    href: this.company.twitter,
                    color: '#fff',
                    backgroundColor: '#1da1f2',
                },
                {
                    id: 'facebook',
                    title: 'Facebook',
                    icon: this.facebookLogo,
                    href: this.company.facebook,
                    color: '#fff',
                    backgroundColor: '#4267b2',
                },
                {
                    id: 'vimeo',
                    title: 'Vimeo',
                    icon: this.vimeoLogo,
                    href: this.company.vimeo,
                    color: '#fff',
                    backgroundColor: '#86c9ef',
                },
                {
                    id: 'we_chat',
                    title: 'WeChat',
                    icon: this.weChatLogo,
                    href: this.company.weChat,
                    color: '#fff',
                    backgroundColor: '#09b83e',
                },
                {
                    id: 'instagram',
                    title: 'Instagram',
                    icon: this.instagramLogo,
                    href: this.company.instagram,
                    color: '#fff',
                    backgroundColor: '#8a3ab9',
                },
                {
                    id: 'linked_in',
                    title: 'LinkedIn',
                    icon: this.linkedInLogo,
                    href: this.company.linkedIn,
                    color: '#fff',
                    backgroundColor: '#0077b5',
                },
            ].filter(x => !!x.href);
        },
        hasLinks(): boolean {
            return !!this.links.length;
        },

        webinars(): VFairWebinar[] {
            const events = this.getEvents();
            return this.filterEventsByHasDuration(events, true);
        },
        videos(): any[] {
            const events = this.getEvents();
            return this.filterEventsByHasDuration(events, false);
        },
    },
    methods: {
        getChatUserToolTip(user: ChatUser): string {
            return joinIfTruthy(' - ', user.displayName, user.title);
        },

        handleChatScroll(delta: number): void {
            this.chatUsersIndex = clamp(this.chatUsersIndex + delta, 0, this.chatUsers.length - 3);
        },
        handleChatUserClick(user: ChatUser): void {
            if (!AuthService.isLoggedIn()) (RestX.getInterfaces() as any).logInModule.toggleOpen();
            this.$root.$emit('chat-conversation-create-update', user.id);
        },

        filterEventsByHasDuration(events: any[], hasDuration: boolean): any[] {
            return events.filter(event => hasDuration === !!(event.startTime && event.endTime));
        },
        getEvents(): any[] {
            if (this.$route.params.id) {
                return this.interfaces.vfair.id(this.$route.params.id).events.get({
                    reactive: true,
                    ownerOrganizationId: this.boothId,
                }).data;
            } else {
                return [];
            }
        },
        getDefaultBackground(): string {
            return defaultBackground;
        },

        resolveRoute(jobAdId: string): string {
            return this.URLS.vfair.concat('/', this.$route.params.id).concat('/jobs/', jobAdId);
        },
        chatAvailabilityTick(): void {
            this.now += this.chatAvailabilityIntervalSeconds;
        },
        logCompanyViewEvent(): void {
            // This triggers an Google Analytics event
            const data = this.company;
            if (!data) return;

            if (data.organizationId) {
                (AnalyticService.companyViewEvent as any)(
                    data.organizationId,
                    data.title,
                    this.$route.params.id,
                    this.pavilionId
                );
                this.hasLoggedEvent = true;
            }
        },
        logBoothLinksClickEvent(linkType: string) {
            AnalyticService.boothLinksClickEvent(
                this.$route.params.id,
                this.pavilionId,
                this.boothId,
                linkType
            );
        },
    },
    mounted() {
        this.boothId = this.$route.params.boothId;

        this.interfaces.vfair
            .id(this.$route.params.id)
            .organizations.organizationId(this.boothId)
            .get()
            .then((company: { data: VFairOrganization }) => {
                this.company = company.data;
                this.companyLoaded = true;
            });

        if (SHOW_CHAT_IN_COMPANY_PROFILE) {
            this.interfaces.communication.chat.availability.id
                .org_id(this.$route.params.boothId)
                .get({ forceUpdate: true });
            this.now = Math.round(new Date().getTime() / 1000);
            this.chatAvailabilityInterval = window.setInterval(
                this.chatAvailabilityTick,
                this.chatAvailabilityIntervalSeconds * 1000
            );
        }
    },
    watch: {
        company(newCompany, oldCompany) {
            // Log company-pageview if it has not been done yet.
            // If you click onto a new company from the this page, we also have to check
            // if the company-ids have updated, so we can log again.
            if (newCompany && (!this.hasLoggedEvent || newCompany.id !== oldCompany.id))
                this.logCompanyViewEvent();
        },
    },
    beforeDestroy() {
        if (SHOW_CHAT_IN_COMPANY_PROFILE) {
            this.chatAvailabilityInterval !== null &&
                window.clearInterval(this.chatAvailabilityInterval);
            this.chatAvailabilityInterval = null;
        }
    },
});
